export var SeverityType;
(function (SeverityType) {
    SeverityType["ERROR"] = "error";
    SeverityType["WARN"] = "warn";
    SeverityType["INFO"] = "info";
    SeverityType["AUTO_DETECT_ERROR"] = "autoDetectError";
    SeverityType["PERFORMANCE"] = "performance";
})(SeverityType || (SeverityType = {}));
// platform type
export var PlatformType;
(function (PlatformType) {
    PlatformType["android"] = "android";
    PlatformType["ios"] = "ios";
    PlatformType["windows"] = "windows";
    PlatformType["macos"] = "macos";
    PlatformType["linux"] = "linux";
    PlatformType["other"] = "other";
})(PlatformType || (PlatformType = {}));
export var Environment;
(function (Environment) {
    Environment["production"] = "prod";
    Environment["demo"] = "demo";
    Environment["staging"] = "staging";
})(Environment || (Environment = {}));
// network type
export var NetworkType;
(function (NetworkType) {
    NetworkType["unknown"] = "unknown";
    NetworkType["wifi"] = "wifi";
    NetworkType["net2g"] = "net2g";
    NetworkType["net3g"] = "net3g";
    NetworkType["net4g"] = "net4g";
    NetworkType["net5g"] = "net5g";
})(NetworkType || (NetworkType = {}));
export var AutoDetectedErrorType;
(function (AutoDetectedErrorType) {
    AutoDetectedErrorType["windowOnError"] = "windowOnError";
    AutoDetectedErrorType["promiseError"] = "promiseError";
    AutoDetectedErrorType["staticFileLoadError"] = "staticFileLoadError";
    AutoDetectedErrorType["unknown"] = "unknown";
})(AutoDetectedErrorType || (AutoDetectedErrorType = {}));
export var PerformanceType;
(function (PerformanceType) {
    PerformanceType["LCP"] = "LCP";
    PerformanceType["FID"] = "FID";
    PerformanceType["CLS"] = "CLS";
    PerformanceType["ASSETS_SPEED"] = "assets_speed";
})(PerformanceType || (PerformanceType = {}));
export var StaticFileType;
(function (StaticFileType) {
    StaticFileType["script"] = "script";
    StaticFileType["media"] = "media";
    StaticFileType["img"] = "image";
    StaticFileType["css"] = "css";
    StaticFileType["unknown"] = "unknown";
})(StaticFileType || (StaticFileType = {}));
